<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-notes-medical"></i> Medicamentos
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>
                                <div
                                    class="col-md-5"
                                    :class="{ 'has-danger': $v.model.dataAplicacao.$error }"
                                >
                                    <label>Data da Aplicação*</label>
                                    <flat-pickr
                                        v-model="model.dataAplicacao"
                                        :config="config"
                                        class="form-control"
                                        placeholder="Selecione"
                                        name="date"
                                    ></flat-pickr>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.aplicacao.$error }"
                                >
                                    <label>Aplicar a cada*</label>
                                    <input
                                        placeholder
                                        type="number"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.aplicacao"
                                    />
                                </div>
                                <div
                                    class="col-md-2"
                                    :class="{ 'dropdown-has-error': $v.model.aplicacaoPeriodo.$error }"
                                >
                                    <label>Periodo*</label>
                                    <Select2
                                        placeholder="Selecionar"
                                        v-model="model.aplicacaoPeriodo"
                                        :options="  aplicacaoPeriodo"
                                        opt-id="id"
                                        opt-text="text"
                                    ></Select2>
                                </div>

                                <div class="col-md-2 align-self-center">
                                    <label>Uso Contínuo?</label>

                                    <input-toggle v-model="model.usoContinuo"></input-toggle>
                                </div>

                                <div v-if="model.usoContinuo" class="col-md-2">
                                    <label>Durante*</label>
                                    <input
                                        placeholder
                                        type="number"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.durante"
                                    />
                                </div>
                                <div v-if="model.usoContinuo" class="col-md-2">
                                    <label>Periodo</label>
                                    <Select2
                                        placeholder="Selecionar"
                                        v-model="model.durantePeriodo"
                                        :options=" periodo"
                                        opt-id="id"
                                        opt-text="text"
                                    ></Select2>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'dropdown-has-error': $v.model.id_via_administracao.$error }"
                                >
                                    <label>Via de Administração*</label>
                                    <select-api
                                        v-model="model.id_via_administracao"
                                        :endpoint="'/viaAdministracao/pesquisa'"
                                        :opt-text="'nome'"
                                        :select-option="true"
                                    ></select-api>
                                </div>
                                <div
                                    class="col-md-2"
                                    :class="{'has-danger': $v.model.dose.$error }"
                                >
                                    <label>Dose*</label>
                                    <input
                                        style="width:200px"
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.dose"
                                    />
                                </div>
                            </div>

                            <br />
                            <br />
                            <div class="form-group row">
                                <div class="col-md-9">
                                    <label>Ações do medicamento</label>
                                    <dw-multi-select
                                        :available="listavailable"
                                        :requested="listrequested"
                                        opt-text="nome"
                                        :disabled="model.enviado"
                                    ></dw-multi-select>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-right">
                            <router-link
                                :to="{name: 'list-medicine-pet', params: { id: this.$route.params.id}}"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
                <!-- ADICIONAR LEMBRETE -->
                <div class="card" v-if="model.id">
                    <div class="card-header">
                        <i class="fas fa-bell"></i> Adicionar Lembrete
                    </div>
                    <div class="card-block form form-horizontal">
                        <div class="form-group row">
                            <div
                                class="col-md-2"
                                :class="{'has-danger': $v.reminder.lembrete.$error }"
                            >
                                <label>Aplicar a cada*</label>
                                <input
                                    placeholder
                                    type="number"
                                    maxlength="100"
                                    class="form-control"
                                    v-model="reminder.lembrete"
                                />
                            </div>
                            <div
                                class="col-md-2"
                                :class="{'dropdown-has-error': $v.reminder.lembretePeriodo.$error }"
                            >
                                <label>Periodo*</label>
                                <Select2
                                    placeholder="Selecionar"
                                    v-model="reminder.lembretePeriodo"
                                    :options=" lembrete"
                                    opt-id="id"
                                    opt-text="text"
                                    :select-option="true"
                                ></Select2>
                            </div>

                            <div class style="margin-top:27px ; margin-left:1%">
                                <button class="btn btn-primary" @click="saveReminder()">Adicionar</button>
                            </div>
                        </div>

                        <div class="card"></div>
                        <div class="form-group row col-md-5">
                            <table class="table table-bordered table-striped table-md">
                                <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>
                                <tbody>
                                    <tr v-for="(item, index) in model.lembretes">
                                        <td :data-label="headers[0].name">
                                            {{ item.lembrete }}
                                            <span
                                                v-if="item.lembretePeriodo=='I'"
                                            >Minutos</span>
                                            <span v-if="item.lembretePeriodo=='H'">Hora(s)</span>
                                            <span v-if="item.lembretePeriodo=='D'">Dia(s)</span>
                                            <span v-if="item.lembretePeriodo=='S'">Semana(s)</span>
                                            <span v-if="item.lembretePeriodo=='M'">Mes(es)</span>
                                            <span v-if="item.lembretePeriodo=='A'">Ano(s)</span>
                                        </td>

                                        <td>
                                            <button
                                                class="btn btn-danger btn-sm"
                                                @click="remove(item.id, index)"
                                            >
                                                <i class="far fa-trash-alt"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Facade from "../../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty,
    formatPhone
} from "@/services/string";
import { isPhone } from "@/services/util";
import Collections from "@/helpers/collections";
import Select2 from "../../../components/Input/Select2";
import FileImage from "../../../components/Input/FileImage";
import SelectApi from "../../../components/Input/SelectApi";
import flatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { request } from "http";

export default {
    components: {
        Select2,
        FileImage,
        SelectApi,
        flatPickr,
        isPhone
    },
    data() {
        return {
            model: {
                id: null,
                idPet: null,
                nome: "",
                dataAplicacao: "",
                aplicacao: "",
                aplicacaoPeriodo: null,
                usoContinuo: false,
                durante: null,
                durantePeriodo: null,
                dose: "",
                id_via_administracao: null,
                acoes: null,
                lembrete: null,
                lembretePeriodo: null
            },
            config: {
                wrap: true,
                enableTime: true,
                time_24hr: true,
                locale: Portuguese,
                altInput: true,
                altFormat: "d/m/Y H:i",
                allowInput: true
            },

            listrequested: [],
            listavailable: [],
            periodo: Collections.periodo,
            aplicacaoPeriodo: Collections.aplicacaoPeriodo,
            lembrete: Collections.lembrete,
            acoes: [],

            lembretes: [],
            headers: [{ name: "A cada", key: "medicamentoLembrete.lembrete" }],
            list: {},
            size: 20,
            page: 0,
            order: ["id", "ASC"],
            reminder: {
                idMedicine: null,
                lembretePeriodo: null,
                lembrete: null
            }
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    validations() {
        return {
            model: {
                dataAplicacao: {
                    required
                },
                nome: {
                    required,
                    minLength: minLength(2)
                },

                id_via_administracao: {
                    required
                },

                dose: {
                    required
                },
                aplicacao: {
                    required
                },
                aplicacaoPeriodo: {
                    required
                }
            },
            reminder: {
                lembretePeriodo: {
                    required
                },
                lembrete: {
                    required
                }
            }
        };
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.setData(this.page);
        },

        async save() {
            let vm = this;

            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);
            vm.model.idPet = this.$route.params.id;
            vm.model.acoes = vm.listrequested;
            try {
                if (vm.model.id) {
                    if (!vm.model.usoContinuo) {
                        vm.model.durante = null;
                        vm.model.durantePeriodo = null;
                    }
                    let ret = await facade.updateMedicine(
                        vm.model,
                        vm.model.id
                    );
                    this.$router.push({
                        name: "edit-medicine-pet",
                        params: {
                            id: this.$route.params.id,
                            idMedicine: this.$route.params.idMedicine
                        }
                    });

                    this.$loading.show(false);
                    this.$notify.success("Atualizado com sucesso.");
                } else {
                    let ret = await facade.createMedicine(vm.model);
                    this.$router.push({
                        name: "edit-medicine-pet",
                        params: {
                            id: this.$route.params.id,
                            idMedicine: ret.data.data.id
                        }
                    });
                    this.$notify.success("Criado  com sucesso.");
                    this.$loading.show(false);
                }
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },

        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(medicine, listavailable, listrequested, page, list) {
            let vm = this;
            vm.page = page;

            if (medicine !== undefined && medicine !== null) {
                this.model = medicine;
            }
            if (listrequested) {
                for (let i = 0; i < listavailable.length; i++) {
                    if (listrequested[i]) {
                        if (listrequested[i].id == listavailable[i].id) {
                            var index = listavailable.indexOf(listavailable[i]);
                            listavailable.splice(index, 1);
                        }
                    }
                }
            }

            this.listavailable = listavailable;

            this.listrequested = listrequested || [];
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        },
        async remove(id, index) {
            try {
                let vm = this;
                await this.$swal({
                    title: "Você tem certeza?",
                    text: "Não será possível reverter esta operação",
                    showCancelButton: true,
                    confirmButtonText: "Sim, deletar!",
                    cancelButtonText: "Não, cancelar!"
                });
                vm.model.lembretes.splice(index, 1);
                let ret = await facade.deleteReminder(id);
                this.$notify.success("Removido  com sucesso.");
                this.$loading.show(false);
            } catch (e) {
                console.log("not accepted");
            }
        },
        async clean() {
            this.reminder = {
                lembretePeriodo: null,
                lembrete: null
            };
        },

        async saveReminder(idMedicine) {
            try {
                let vm = this;
                if (this.$v.reminder.$invalid) {
                    this.$v.reminder.$touch();
                    this.$notify.warning(
                        "Atenção!",
                        "Verifique se todos os campos estão preenchidos corretamente."
                    );
                    return;
                }

                this.$loading.show(true);
                this.$notify.success("Lembrete criado  com sucesso.");

                vm.reminder.idMedicine = vm.model.id;

                let ret = await facade.createReminder(vm.reminder);

                this.model.lembretes.push(ret.data.data);

                await this.clean();
                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        const vm = this;
        let model = null;
        let listavailable = null;
        let listrequested = null;

        listavailable = await facade.listAcao();
        listavailable = listavailable != null ? listavailable.data.data : [];

        // Reescrever a lista
        listavailable.map(item => {
            item.text = item.nome;
            return item;
        });

        if (to.params.idMedicine) {
            model = await facade.getMedicine(to.params.idMedicine);
            model = model != null ? model.data.data : null;
            listrequested = model.acoes.map(item => {
                item.text = item.nome;
                return item;
            });
        }
        next(vm => vm.setData(model, listavailable, listrequested));
    }
};
</script>




// WEBPACK FOOTER //
// Form.vue?168a512d